import { AsyncFunction } from "./AsyncFunction";

//開催日フォーマット
//使用例：formatDate(new Date(party_data.party_date), 'YYYY/MM/DD  (aa)')  出力：2022/7/15 (金)
export const formatDate = function (date, format) {
    format = format.replace(/YYYY/, date.getFullYear());
    format = format.replace(/MM/, date.getMonth() + 1);
    format = format.replace(/DD/, date.getDate());
    format = format.replace(/aa/, [ "日", "月", "火", "水", "木", "金", "土" ][date.getDay()]);
 
    return format;
};

//開始時間フォーマット
//使用例：formatTime(new Date(party_data.party_date + ' ' + party_data.party_start_time))  出力：14:54
export const formatTime = function (date){
    var h = date.getHours();
    var m = date.getMinutes();

    if (h < 10) h = '0' + h;
    
    if (m < 10) m = '0' + m;
    
    var hm = h + ':' + m;
    
    return hm;
};

//6営業日後を取得
export const getEnableDate = function (arg) {
    const params = {
        url: "/api/GetEnableDate",
        method: "get",
        params: { ...arg },
        type_name: "GetEnableDate",
    };
    return AsyncFunction(params);
};